<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Settings'"></Breadcrumbs>
    </div>
    <div class="col-md-12 home-tabs-body">
     <Setting></Setting>
    </div>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Setting from "@/components/settings/Setting";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Settings",
  components: {
    Breadcrumbs,
    Setting,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>

